module.exports = Hammer;